import styled from 'styled-components';
import { minHeight100vh } from '../../helpers/style-helpers';

export const LayoutSC = styled.div`
  ${minHeight100vh()}

  display: flex;
  flex-direction: column;
  padding-top: 60px;
  padding-left: 200px;

  transition: padding 0.2s;

  .sidebar-collapsed & {
    padding-left: 72px;
  }
`;
